const Prices: React.FC = () => {
  return (
    <section id="sweptbooks-prices" className="container"></section>
  )
}

export default Prices